module.exports = __webpack_public_path__ + "static/media/bg_waves_full_screen.e393cf7b.svg";